<template>
  <svg :width="width" :height="height" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.9116 4.23431L9.5 0L0.0884482 4.23431C0.0884482 10.3096 -1.57241 17.4895 9.5 22C20.5724 17.3975 18.9116 10.3096 18.9116 4.23431ZM14.3903 9.48117L12.0836 11.3222L12.8217 14.1757C12.914 14.4519 12.8217 14.636 12.6372 14.8201C12.4526 15.0042 12.1758 15.0042 11.9913 14.8201L9.5 13.1632L7.10098 14.728C6.91644 14.8201 6.63963 14.8201 6.45509 14.728C6.27055 14.5439 6.17828 14.3598 6.27055 14.0837L7.00871 11.2301L4.70195 9.38912C4.51741 9.20502 4.42514 9.02092 4.51741 8.74477C4.60968 8.46862 4.79422 8.37657 5.07103 8.37657L7.93141 8.28452L8.94638 5.52301C9.03865 5.33891 9.22319 5.15481 9.5 5.15481C9.77681 5.15481 9.96135 5.33891 10.0536 5.52301L11.0686 8.28452L14.0212 8.37657C14.298 8.37657 14.4826 8.56067 14.5749 8.74477C14.6671 9.02092 14.5749 9.29707 14.3903 9.48117Z" :fill="color"/>
  </svg>
</template>

<script>
export default{
  name: 'subscTypeIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '20'
    },
    height: {
      type: [String, Number],
      default: '20'
    }
  }
}</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/SubscTypeIcon.vue